import React, { useReducer } from 'react';
import { Form, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import { onChangeFunction } from 'shared';
import { Button } from 'components/blocks';

const reducer = (state, newState) => ({ ...state, ...newState });
const INITIAL_STATE = {
    email: '',
};

export const ResetForm = props => {
    const { loading, onSubmit, setReset } = props;
    const [form, setForm] = useReducer(reducer, INITIAL_STATE);
    const { email } = form;
    const submitHandler = async e => {
        e.preventDefault();
        onSubmit(form);
    };
    return (
        <Form onSubmit={loading ? null : submitHandler}>
            <h2 className="text-uppercase text-darkgreen mb-1">Reset Password</h2>
            <p>
                Enter your email address below and a reset password link
                <br />
                will be sent to you.
            </p>
            <Input
                type="email"
                name="email"
                className="form-control form-control-lg mb-4"
                style={{ background: '#FFF' }}
                placeholder="Email Address"
                value={email}
                onChange={evt => onChangeFunction.handleChange(evt, setForm)}
            />
            <Button
                type="submit"
                color="primary"
                className="btn-lg btn-block btn-round"
                loading={loading}
                disabled={email.length === 0}
            >
                Send Reset Link
            </Button>
            <div className="mt-5 text-center">
                <div
                    onClick={() => setReset(false)}
                    className="body-text-link cursor-pointer"
                >
                    <FontAwesomeIcon icon={faArrowLeft} /> back to login
                </div>
            </div>
        </Form>
    );
};
